import Layout from 'components/layout';
import ContentPage from 'components/content-pages';
import { handleContentPageServerSideProps } from 'utils/content-pages';
import { createGetServerSideProps, HandlerType } from 'utils/next/shared-getServerSideProps';
import { EXP_REALTY_US_TENANT_ID } from '@tenants/types';
import { FeaturesType } from 'contexts/features';
import { TenantTypes } from '@tenants';

import type { GetServerSidePropsContext } from 'next';
import type { ContentPageProps } from 'types/content-pages';
import { useEffect } from 'react';

const handler: HandlerType<ContentPageProps> = async (context: GetServerSidePropsContext, _features?: FeaturesType, tenant?: TenantTypes) => {
  const guideQuery = context.query.dynamic as string[];
  const guideUrl = guideQuery.join('/');
  return await handleContentPageServerSideProps(tenant.id, [EXP_REALTY_US_TENANT_ID], `/guides/${guideUrl}`);
};

export const getServerSideProps = createGetServerSideProps<ContentPageProps>(handler);


export default function DynamicAgentPage(props: ContentPageProps) {
  useEffect(() => {
    // Change all of the hard links to relative ones so we don't go to the wordpress site
    const anchors = document.getElementsByTagName('a');
    for (const a of anchors) {
      a.href = a.href.replace('https://exp-us.content.zoocasa.com', '');
    }
  }, []);

  return (
    <Layout>
      <ContentPage {...props} />
    </Layout>
  );
}
